
export enum coreType {
    none = 'none',
    O_X4 = 'O-X4',
    O_X5 = 'O-X5',
    O_X6 = 'O-X6',
}